import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';

var FormErrors = function FormErrors(_ref) {
  var fields = _ref.fields;
  return /*#__PURE__*/React.createElement("div", {
    className: "formErrors mb-3"
  }, fields.length ? fields.map(function (field, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "mb-1"
    }, /*#__PURE__*/React.createElement("small", {
      className: "text-danger"
    }, field.error));
  }) : null);
};

FormErrors.propTypes = {
  fields: PropTypes.array
};
export default FormErrors;